// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Input,
//   FormControl,
//   FormLabel,
//   Select,
//   VStack,
//   Heading,
//   HStack,
//   IconButton,
//   Text,
//   useDisclosure,
//   NumberInput,
//   NumberInputField,
//   Switch,
//   Popover,
//   PopoverTrigger,
//   PopoverContent,
//   Flex,
// } from "@chakra-ui/react";
// import { CalendarIcon, TimeIcon, CloseIcon } from "@chakra-ui/icons";
// import { format } from "date-fns";
// import CalendarModal from "./Calender"; // custom component you'll build next
// import { RepeatIntervalSelect } from "./RepeatIntervalSelect";
// import { Clock, RotateCcw } from "lucide-react";
// import { Calendar } from "./Calender1";

// export default function SchedularWorkFlow({
//   formData,
//   setFormData,
//   onCloseSchedular,
// }) {
//   const {
//     isOpen: isDatePickerOpen,
//     onOpen: openDatePicker,
//     onClose: closeDatePicker,
//   } = useDisclosure();

//   const [isRecurring, setIsRecurring] = useState(false);

//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const handleDateSelect = (date) => {
//     setFormData((prev) => ({ ...prev, start_date: date }));
//     onClose();
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//   };

//   const [loading, setLoading] = useState(false);

//   const handleSubmitForm = async () => {
//     setLoading(true);
//     try {
//       // const res= await scheduleAutomationWorkflowApi(formData)
//     } catch (error) {
//     } finally {
//       setLoading(false);
//       onCloseSchedular();
//     }
//   };

//   return (
//     <Box
//       // minH="100vh"
//       w={"100%"}
//       color="white"
//       display="flex"
//       alignItems="center"
//       justifyContent="center"
//     >
//       <Box bg="white" color="black" rounded="md" shadow="lg" w="100%" maxW="md">
//         <HStack justifyContent="space-between" mb={4}>
//           <Heading size="md">Schedule a Workflow</Heading>
//         </HStack>

//         <form onSubmit={handleSubmit}>
//           <VStack spacing={2} align="stretch">
//             {/* Cycle Type */}
//             <FormControl>
//               <FormLabel fontSize="sm" color="gray.700">
//                 Cycle Type
//               </FormLabel>
//               <Select
//                 value={formData.cycleType}
//                 onChange={(e) => {
//                   setFormData((prev) => ({
//                     ...prev,
//                     cycleType: e.target.value,
//                   }));
//                   if (e.target.value === "regular_interval") {
//                     setIsRecurring(true);
//                   } else {
//                     setIsRecurring(false);
//                   }
//                 }}
//               >
//                 <option value="immediate">immediate</option>
//                 <option value="regular_interval">regular interval</option>
//                 <option value="custom">custom</option>
//               </Select>
//             </FormControl>
//             <HStack justifyContent={"space-between"}>
//               <Box>
//                 <FormLabel
//                   fontSize="sm"
//                   color="gray.700"
//                   textColor={
//                     formData.cycleType === "immediate" ? "gray.500" : ""
//                   }
//                 >
//                   Start Date
//                 </FormLabel>
//                 <Popover isOpen={isDatePickerOpen} onClose={closeDatePicker}>
//                   <PopoverTrigger>
//                     <Button
//                       isDisabled={formData.cycleType === "immediate"}
//                       onClick={openDatePicker}
//                       w="100%"
//                       h="40px"
//                       border="1px solid #eef4ff"
//                       bg="#f6f9ff"
//                       leftIcon={<CalendarIcon size={12} color="#6c7275" />}
//                     >
//                       {formData.start_date
//                         ? format(formData.start_date, "PPP")
//                         : "Select date"}
//                     </Button>
//                   </PopoverTrigger>
//                   <PopoverContent w="auto" p={0}>
//                     <Calendar
//                       mode="single"
//                       selected={formData.start_date || undefined}
//                       onSelect={(date) => {
//                         setFormData({ ...formData, start_date: date });
//                         closeDatePicker();
//                       }}
//                     />
//                   </PopoverContent>
//                 </Popover>
//               </Box>

//               <Box>
//                 <FormLabel
//                   fontSize="sm"
//                   color="gray.700"
//                   textColor={
//                     formData.cycleType === "immediate" ? "gray.500" : ""
//                   }
//                 >
//                   Start Time
//                 </FormLabel>
//                 <Flex
//                   align="center"
//                   bg="#f6f9ff"
//                   border="1px solid #eef4ff"
//                   h="40px"
//                   px={2}
//                   rounded="md"
//                 >
//                   {/* <Clock size={16} color="#6c7275" /> */}
//                   <Input
//                     type="time"
//                     value={formData?.start_time}
//                     isDisabled={formData.cycleType === "immediate"}
//                     onChange={(e) =>
//                       setFormData({ ...formData, start_time: e.target.value })
//                     }
//                     border="none"
//                     bg="transparent"
//                     _focus={{ boxShadow: "none" }}
//                   />
//                 </Flex>
//               </Box>
//             </HStack>

//             {formData.cycleType === "immediate" && (
//               <HStack justify="space-between" align="center">
//                 <FormLabel
//                   htmlFor="recurring-switch"
//                   fontSize="sm"
//                   color="gray.700"
//                   mb="0"
//                 >
//                   Recurring
//                 </FormLabel>
//                 <Switch
//                   id="recurring-switch"
//                   isChecked={isRecurring}
//                   onChange={(e) => setIsRecurring(e.target.checked)}
//                   colorScheme="blue"
//                 />
//               </HStack>
//             )}

//             {(isRecurring || formData.cycleType == "regular_interval") && (
//               <VStack spacing={4} align="stretch">
//                 <Box>
//                   <FormLabel fontSize="sm" color="gray.700">
//                     Number of Cycles
//                   </FormLabel>
//                   <Flex
//                     align="center"
//                     bg="#f6f9ff"
//                     border="1px solid #eef4ff"
//                     h="48px"
//                     px={3}
//                     rounded="md"
//                   >
//                     <RotateCcw size={16} color="#6c7275" />
//                     <Input
//                       type="number"
//                       _placeholder={{ color: "gray.500" }}
//                       placeholder={10}
//                       value={formData.cycle_count || ""}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           cycle_count: Number(e.target.value),
//                         })
//                       }
//                       border="none"
//                       bg="transparent"
//                       _focus={{ boxShadow: "none" }}
//                       min={1}
//                     />
//                   </Flex>
//                 </Box>

//                 <FormControl>
//                   <FormLabel fontSize="sm" color="gray.700">
//                     Repeat Every
//                   </FormLabel>
//                   <HStack justifyContent={"space-between"}>
//                     <NumberInput
//                       min={1}
//                       size="sm"
//                       flex="1"
//                       _placeholder={{ color: "gray.500" }}
//                       placeholder={10}
//                       value={formData.repeat_interval || ""}
//                       onChange={(valueString, valueNumber) =>
//                         setFormData((prev) => ({
//                           ...prev,
//                           repeat_interval: valueNumber,
//                         }))
//                       }
//                     >
//                       <NumberInputField
//                         placeholder="10"
//                         _placeholder={{ color: "gray.500" }}
//                       />
//                     </NumberInput>
//                     <RepeatIntervalSelect
//                       value={formData.repeat_unit}
//                       onChange={(value) =>
//                         setFormData((prev) => ({
//                           ...prev,
//                           repeat_unit: value,
//                         }))
//                       }
//                     />
//                   </HStack>
//                 </FormControl>
//               </VStack>
//             )}

//             {/* Submit */}
//             <Button
//               onClick={handleSubmitForm}
//               type="submit"
//               colorScheme="blue"
//               w="full"
//             >
//               save
//               {/* {loading ? "Scheduling" : "Schedule"} */}
//             </Button>
//           </VStack>
//         </form>
//       </Box>

//       {/* Calendar Modal */}
//       <CalendarModal
//         isOpen={isOpen}
//         onClose={onClose}
//         onDateSelect={handleDateSelect}
//         start_date={formData.start_date}
//       />
//     </Box>
//   );
// }

import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  FormControl,
  FormLabel,
  Select,
  VStack,
  Heading,
  HStack,
  useDisclosure,
  NumberInput,
  NumberInputField,
  Switch,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Flex,
} from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import { format } from "date-fns";
import CalendarModal from "./Calender";
import { RepeatIntervalSelect } from "./RepeatIntervalSelect";
import { RotateCcw } from "lucide-react";
import { Calendar } from "./Calender1";

export default function SchedularWorkFlow({
  formData,
  setFormData,
  onCloseSchedular,
}) {
  const {
    isOpen: isDatePickerOpen,
    onOpen: openDatePicker,
    onClose: closeDatePicker,
  } = useDisclosure();

  const [isRecurring, setIsRecurring] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleDateSelect = (date) => {
    setFormData((prev) => ({ ...prev, start_date: date }));
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleSubmitForm = async () => {
    const newErrors = {};

    if (!formData.cycleType) newErrors.cycleType = "Cycle type is required";

    if (formData.cycleType !== "immediate" && !formData.start_date)
      newErrors.start_date = "Start date is required";

    if (formData.cycleType !== "immediate" && !formData.start_time)
      newErrors.start_time = "Start time is required";

    if (isRecurring || formData.cycleType === "regular_interval") {
      if (!formData.cycle_count)
        newErrors.cycle_count = "Number of cycles is required";
      if (!formData.repeat_interval)
        newErrors.repeat_interval = "Repeat interval is required";
      if (!formData.repeat_unit)
        newErrors.repeat_unit = "Repeat unit is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    try {
      // await scheduleAutomationWorkflowApi(formData)
    } catch (error) {
    } finally {
      setLoading(false);
      onCloseSchedular();
    }
  };

  return (
    <Box
      w={"100%"}
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box bg="white" color="black" rounded="md" shadow="lg" w="100%" maxW="md">
        <HStack justifyContent="space-between" mb={4}>
          <Heading size="md">Schedule a Workflow</Heading>
        </HStack>

        <form onSubmit={handleSubmit}>
          <VStack spacing={2} align="stretch">
            {/* Cycle Type */}
            <FormControl isRequired isInvalid={!!errors.cycleType}>
              <FormLabel fontSize="sm" color="gray.700">
                Cycle Type
              </FormLabel>
              <Select
                value={formData.cycleType}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    cycleType: e.target.value,
                  }));
                  if (e.target.value === "regular_interval") {
                    setIsRecurring(true);
                  } else {
                    setIsRecurring(false);
                  }
                  setErrors({})
                }}
              >
                <option value="">Select cycle type</option>
                <option value="immediate">immediate</option>
                <option value="regular_interval">regular interval</option>
                <option value="custom">custom</option>
              </Select>
            </FormControl>

            <HStack justifyContent={"space-between"}>
              <FormControl isRequired isInvalid={!!errors.start_date}>
                <FormLabel
                  fontSize="sm"
                  color="gray.700"
                  textColor={
                    formData.cycleType === "immediate" ? "gray.500" : ""
                  }
                >
                  Start Date
                </FormLabel>
                <Popover isOpen={isDatePickerOpen} onClose={closeDatePicker}>
                  <PopoverTrigger>
                    <Button
                      isDisabled={formData.cycleType === "immediate"}
                      onClick={openDatePicker}
                      w="100%"
                      h="40px"
                      border="1px solid #eef4ff"
                      bg="#f6f9ff"
                      leftIcon={<CalendarIcon size={12} color="#6c7275" />}
                    >
                      {formData.start_date
                        ? format(formData.start_date, "PPP")
                        : "Select date"}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent w="auto" p={0}>
                    <Calendar
                      mode="single"
                      selected={formData.start_date || undefined}
                      onSelect={(date) => {
                        setFormData({ ...formData, start_date: date });
                        closeDatePicker();
                      }}
                    />
                  </PopoverContent>
                </Popover>
              </FormControl>

              <FormControl isRequired isInvalid={!!errors.start_time}>
                <FormLabel
                  fontSize="sm"
                  color="gray.700"
                  textColor={
                    formData.cycleType === "immediate" ? "gray.500" : ""
                  }
                >
                  Start Time
                </FormLabel>
                <Flex
                  align="center"
                  bg="#f6f9ff"
                  border="1px solid #eef4ff"
                  h="40px"
                  px={2}
                  rounded="md"
                >
                  <Input
                    type="time"
                    value={formData?.start_time}
                    isDisabled={formData.cycleType === "immediate"}
                    isRequired
                    onChange={(e) =>
                      setFormData({ ...formData, start_time: e.target.value })
                    }
                    border="none"
                    bg="transparent"
                    _focus={{ boxShadow: "none" }}
                  />
                </Flex>
              </FormControl>
            </HStack>

            {formData.cycleType === "immediate" && (
              <HStack justify="space-between" align="center">
                <FormLabel
                  htmlFor="recurring-switch"
                  fontSize="sm"
                  color="gray.700"
                  mb="0"
                >
                  Recurring
                </FormLabel>
                <Switch
                  id="recurring-switch"
                  isChecked={isRecurring}
                  onChange={(e) => setIsRecurring(e.target.checked)}
                  colorScheme="blue"
                />
              </HStack>
            )}

            {(isRecurring || formData.cycleType === "regular_interval") && (
              <VStack spacing={4} align="stretch">
                <FormControl isRequired isInvalid={!!errors.cycle_count}>
                  <FormLabel fontSize="sm" color="gray.700">
                    Number of Cycles
                  </FormLabel>
                  <Flex
                    align="center"
                    bg="#f6f9ff"
                    border="1px solid #eef4ff"
                    h="48px"
                    px={3}
                    rounded="md"
                  >
                    <RotateCcw size={16} color="#6c7275" />
                    <Input
                      type="number"
                      placeholder={10}
                      value={formData.cycle_count || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cycle_count: Number(e.target.value),
                        })
                      }
                      border="none"
                      bg="transparent"
                      _focus={{ boxShadow: "none" }}
                      min={1}
                      isRequired
                    />
                  </Flex>
                </FormControl>
                <HStack w={"100%"} justifyContent={"space-between"}>
                  {/* Repeat Interval */}
                  <FormControl
                    isRequired
                    isInvalid={!!errors.repeat_interval}
                    flex="1"
                    mr={2}
                    w={"60%"}
                  >
                    <FormLabel fontSize="sm" color="gray.700">
                      Repeat Interval
                    </FormLabel>
                    <NumberInput
                      min={1}
                      size="sm"
                      value={formData.repeat_interval || ""}
                      onChange={(valueString, valueNumber) =>
                        setFormData((prev) => ({
                          ...prev,
                          repeat_interval: valueNumber,
                        }))
                      }
                      isRequired
                    >
                      <NumberInputField isRequired />
                    </NumberInput>
                  </FormControl>

                  {/* Repeat Unit */}
                  <FormControl
                    isRequired
                    isInvalid={!!errors.repeat_unit}
                    flex="1"
                    ml={2}
                    w={"40%"}
                  >
                    <FormLabel fontSize="sm" color="gray.700">
                      Repeat Unit
                    </FormLabel>
                    <RepeatIntervalSelect
                      value={formData.repeat_unit}
                      onChange={(value) =>
                        setFormData((prev) => ({
                          ...prev,
                          repeat_unit: value,
                        }))
                      }
                      isRequired
                    />
                  </FormControl>
                </HStack>

                {/* <FormControl isRequired isInvalid={!!errors.repeat_interval || !!errors.repeat_unit}>
                  <FormLabel fontSize="sm" color="gray.700">
                    Repeat Every
                  </FormLabel>
                  <HStack justifyContent={"space-between"}>
                    <NumberInput
                      min={1}
                      size="sm"
                      flex="1"
                      placeholder={10}
                      value={formData.repeat_interval || ""}
                      onChange={(valueString, valueNumber) =>
                        setFormData((prev) => ({
                          ...prev,
                          repeat_interval: valueNumber,
                        }))
                      }
                      isRequired
                    >
                      <NumberInputField isRequired />
                    </NumberInput>
                    <RepeatIntervalSelect
                      value={formData.repeat_unit}
                      onChange={(value) =>
                        setFormData((prev) => ({
                          ...prev,
                          repeat_unit: value,
                        }))
                      }
                      isRequired
                    />
                  </HStack>
               
                </FormControl> */}
              </VStack>
            )}

            {/* Submit */}
            <Button
              onClick={handleSubmitForm}
              type="submit"
              colorScheme="blue"
              w="full"
              isLoading={loading}
            >
              Save
            </Button>
          </VStack>
        </form>
      </Box>

      {/* Calendar Modal */}
      <CalendarModal
        isOpen={isOpen}
        onClose={onClose}
        onDateSelect={handleDateSelect}
        start_date={formData.start_date}
      />
    </Box>
  );
}
